/**
 * Topic labels for the "500+ questions" clusters. Kept in a data-free module so
 * both the hub and the topic sub-hub routes can import them without pulling in
 * the (large) Q&A datasets of other clusters.
 */

export const VISA_TOPIC_LABELS: Record<string, string> = {
  definition: "นิยาม / วีซ่าคืออะไร",
  price: "ค่าบริการและการขอใบเสนอราคา",
  process: "ขั้นตอนการยื่น",
  documents: "เอกสารที่ต้องเตรียม",
  speed: "ระยะเวลา / เร่งด่วน",
  extension: "ต่อวีซ่า / ขยายเวลา",
  refusal: "วีซ่าถูกปฏิเสธ / อุทธรณ์",
  country: "รายประเทศ",
  compare: "เปรียบเทียบวีซ่า",
  family: "ครอบครัว / คู่สมรส",
  work: "ทำงาน / Work Permit",
  retirement: "เกษียณ",
  longstay: "อยู่ระยะยาว / PR",
  legal: "กฎหมาย / อื่น ๆ",
};

export const PCC_TOPIC_LABELS: Record<string, string> = {
  definition: "นิยาม / PCC คืออะไร",
  price: "ค่าธรรมเนียมและการขอใบเสนอราคา",
  process: "ขั้นตอน / กระบวนการ",
  documents: "เอกสารที่ต้องเตรียม",
  speed: "ความเร่งด่วน / ระยะเวลา",
  location: "สถานที่ / พื้นที่ให้บริการ",
  embassy: "สถานทูตปลายทาง",
  apostille: "Apostille / กรมการกงสุล",
  translation: "การแปลและรับรองคำแปล",
  overseas: "ขอจากต่างประเทศ",
  foreigner: "สำหรับต่างชาติในไทย",
  employment: "สมัครงาน / ทำงานต่างประเทศ",
  legal: "ประวัติ / คดี / ข้อกฎหมาย",
};

export const MOJ_TOPIC_LABELS: Record<string, string> = {
  definition: "นิยาม / แปล MoJ คืออะไร",
  price: "ค่าบริการและการขอใบเสนอราคา",
  speed: "ระยะเวลา / งานด่วน",
  process: "ขั้นตอนการทำงาน",
  documents: "เอกสารที่ต้องเตรียม",
  court: "งานศาลและคดีความ",
  contract: "นิติกรรมสัญญา",
  corporate: "เอกสารบริษัท",
  expat: "สำหรับชาวต่างชาติ",
  certification: "รับรอง / Apostille / สถานทูต",
  compare: "เปรียบเทียบ MoJ / Notary / Sworn",
  "use-case": "จุดประสงค์เฉพาะ",
  legal: "กฎหมาย / อื่น ๆ",
};

export const SWORN_TOPIC_LABELS: Record<string, string> = {
  definition: "นิยาม / Sworn Translator คืออะไร",
  price: "ค่าบริการและการขอใบเสนอราคา",
  process: "ขั้นตอน / กระบวนการ",
  documents: "เอกสารแต่ละประเภท",
  speed: "ระยะเวลา / งานด่วน",
  embassy: "รายสถานทูต",
  language: "ภาษา / เทียบ NAATI",
  apostille: "Apostille / กรมการกงสุล",
  acceptance: "การยอมรับของสถานทูต",
  legal: "กฎหมาย / อื่น ๆ",
};

export const APOSTILLE_TOPIC_LABELS: Record<string, string> = {
  definition: "Apostille คืออะไร",
  price: "ค่าธรรมเนียมและการขอใบเสนอราคา",
  speed: "ความเร่งด่วน / ระยะเวลา",
  process: "ขั้นตอน",
  documents: "ตามประเภทเอกสาร",
  country: "ตามประเทศปลายทาง",
  inbound: "Apostille ต่างประเทศใช้ในไทย",
  problem: "ปัญหาที่พบบ่อย",
  compare: "เปรียบเทียบเส้นทางรับรอง",
};

export const BIG_CLUSTER_REVIEWED_ISO = "2026-08-08T00:00:00.000Z";
export const BIG_CLUSTER_REVIEWED_TH = "สิงหาคม 2569";

export const LGZ_TOPIC_LABELS: Record<string, string> = {
  definition: "นิติกรณ์ / รับรองกงสุล คืออะไร",
  price: "ค่าธรรมเนียมและการขอใบเสนอราคา",
  speed: "ความเร่งด่วน / ระยะเวลา",
  process: "ขั้นตอนและการยื่น",
  documents: "แยกตามประเภทเอกสาร",
  country: "แยกตามประเทศปลายทาง",
  inbound: "เอกสารต่างประเทศใช้ในไทย",
  online: "ยื่นออนไลน์",
  location: "สถานที่และเวลาทำการ",
  problem: "ปัญหาที่พบบ่อย",
  compare: "เปรียบเทียบเส้นทางรับรอง",
};

export const NOTARY_TOPIC_LABELS: Record<string, string> = {
  definition: "Notary Public คืออะไร",
  price: "ค่าบริการและการขอใบเสนอราคา",
  process: "ขั้นตอนการรับรอง",
  documents: "แยกตามประเภทเอกสาร",
  speed: "ความเร่งด่วน / ระยะเวลา",
  location: "สถานที่และพื้นที่ให้บริการ",
  embassy: "สถานทูตปลายทาง",
  apostille: "Apostille / กรมการกงสุล",
  translation: "การแปลและรับรองคำแปล",
  online: "ออนไลน์ / e-Notary",
  compare: "เปรียบเทียบเส้นทางรับรอง",
  legal: "เอกสารกฎหมายและสัญญา",
};

export const NAATI_TOPIC_LABELS: Record<string, string> = {
  definition: "NAATI คืออะไร",
  price: "ค่าบริการและการขอใบเสนอราคา",
  process: "ขั้นตอนการแปลรับรอง",
  documents: "แยกตามประเภทเอกสาร",
  speed: "ความเร่งด่วน / ระยะเวลา",
  location: "สถานที่และพื้นที่ให้บริการ",
  embassy: "สถานทูตและหน่วยงานปลายทาง",
  visa: "วีซ่า / PR / สัญชาติ",
  translation: "คู่ภาษาและงานแปล",
  online: "ออนไลน์ / ไฟล์ดิจิทัล",
  compare: "เปรียบเทียบกับการรับรองอื่น",
  legal: "เอกสารกฎหมายและสัญญา",
  relationship: "ความสัมพันธ์ / คู่ครอง / ครอบครัว",
  verify: "การตรวจสอบตราประทับและนักแปล",
};
